import React from 'react';
import { FileTextIcon, BuildingIcon, ClipboardCheckIcon, FileSearchIcon, CreditCardIcon, MapPinIcon } from 'lucide-react';
export const QuickAccessWidget = () => {
  const quickActions = [{
    title: 'New Business License',
    description: 'Start a new business license application',
    icon: BuildingIcon,
    color: 'bg-blue-100 text-blue-700'
  }, {
    title: 'Building Permit',
    description: 'Apply for a new building or renovation permit',
    icon: FileTextIcon,
    color: 'bg-purple-100 text-purple-700'
  }, {
    title: 'Schedule Inspection',
    description: 'Book a property or business inspection',
    icon: ClipboardCheckIcon,
    color: 'bg-green-100 text-green-700'
  }, {
    title: 'Search Property Records',
    description: 'Look up property information and history',
    icon: FileSearchIcon,
    color: 'bg-yellow-100 text-yellow-700'
  }, {
    title: 'Process Payment',
    description: 'Record or process a payment for any service',
    icon: CreditCardIcon,
    color: 'bg-red-100 text-red-700'
  }, {
    title: 'Address Change',
    description: 'Process an address change request',
    icon: MapPinIcon,
    color: 'bg-indigo-100 text-indigo-700'
  }];
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-2033">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-2034">
        <h2 className="text-lg font-medium text-gray-900" data-id="element-2035">Quick Access</h2>
      </div>
      <div className="p-6" data-id="element-2036">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-2037">
          {quickActions.map((action, index) => <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 cursor-pointer transition-colors duration-150" data-id="element-2038">
              <div className={`inline-flex p-2 rounded-lg ${action.color} mb-3`} data-id="element-2039">
                <action.icon className="h-5 w-5" data-id="element-2040" />
              </div>
              <h3 className="text-sm font-medium text-gray-900" data-id="element-2041">
                {action.title}
              </h3>
              <p className="text-xs text-gray-500 mt-1" data-id="element-2042">{action.description}</p>
            </div>)}
        </div>
      </div>
    </div>;
};